export const linearInterpolation = (x0: number, x1: number, y0: number, y1: number, x: number) => (
    y0 + ((x - x0) * (y1 - y0)) / (x1 - x0)
);

export const transformValue = (
    val1: number,
    val2: number,
    val3: number,
    transform1: number,
    transform2: number,
    transform3: number,
    inputValue: number
) => {
    if (inputValue <= val1) {
        return transform1;
    }

    if (inputValue >= val3) {
        return transform3;
    }

    if (inputValue === val2) {
        return transform2;
    }

    return inputValue < val2
        ? linearInterpolation(val1, val2, transform1, transform2, inputValue)
        : linearInterpolation(val2, val3, transform2, transform3, inputValue);
}
